(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class YGMobileNavigationHeader extends HTMLElement {
    connectedCallback() {
      this.section = document.getElementById(this.getAttribute('section-id'));
      this.drawer = document.getElementById(this.getAttribute('drawer-id'));
      this.header = this.section?.querySelector('.header');
      this.toggleButton = this.header?.querySelector(`[aria-controls="${this.getAttribute('drawer-id')}"]`);
      this.titleElement = this.header?.querySelector('.yg-mobile-menu-title');

      if (!this.header || !this.drawer || !this.toggleButton || !this.titleElement) {
        return;
      }

      this.isActive = false;
      this.backPanel = '';
      this.panelStack = [];
      this.mobileMedia = window.matchMedia('(max-width: 1149px)');
      this.onDrawerClick = this.onDrawerClick.bind(this);
      this.onHeaderPointerDown = this.onHeaderPointerDown.bind(this);
      this.onHeaderToggleClick = this.onHeaderToggleClick.bind(this);
      this.updateState = this.updateState.bind(this);
      this.ignoreNextHeaderClick = false;
      this.lastHeaderBackAt = 0;
      this.preventDrawerHideUntil = 0;
      this.originalDrawerHide = this.drawer.hide?.bind(this.drawer);
      this.drawerObserver = new MutationObserver(this.updateState);
      this.toggleObserver = new MutationObserver(this.updateState);

      if (this.originalDrawerHide) {
        this.drawer.hide = (...args) => {
          if (this.isProtectingBackNavigation()) {
            return;
          }

          return this.originalDrawerHide(...args);
        };
      }

      document.addEventListener('pointerdown', this.onHeaderPointerDown, true);
      document.addEventListener('mousedown', this.onHeaderPointerDown, true);
      document.addEventListener('touchstart', this.onHeaderPointerDown, { capture: true, passive: false });
      document.addEventListener('click', this.onHeaderToggleClick, true);
      this.drawer.addEventListener('click', this.onDrawerClick, true);
      this.drawer.addEventListener('dialog:after-hide', this.updateState);
      this.mobileMedia.addEventListener('change', this.updateState);
      this.drawerObserver.observe(this.drawer, {
        attributes: true,
        attributeFilter: ['aria-expanded', 'open'],
        subtree: true
      });
      this.toggleObserver.observe(this.toggleButton, {
        attributes: true,
        attributeFilter: ['aria-expanded']
      });

      this.updateState();
    }

    disconnectedCallback() {
      document.removeEventListener('pointerdown', this.onHeaderPointerDown, true);
      document.removeEventListener('mousedown', this.onHeaderPointerDown, true);
      document.removeEventListener('touchstart', this.onHeaderPointerDown, true);
      document.removeEventListener('click', this.onHeaderToggleClick, true);
      this.drawer?.removeEventListener('click', this.onDrawerClick, true);
      this.drawer?.removeEventListener('dialog:after-hide', this.updateState);
      this.mobileMedia?.removeEventListener('change', this.updateState);
      this.drawerObserver?.disconnect();
      this.toggleObserver?.disconnect();

      if (this.originalDrawerHide) {
        this.drawer.hide = this.originalDrawerHide;
      }
    }

    updateState() {
      const isDrawerOpen = this.toggleButton.getAttribute('aria-expanded') === 'true';

      if (!isDrawerOpen || !this.mobileMedia.matches) {
        this.panelStack = [];
      }

      this.renderState();
    }

    renderState() {
      const currentPanel = this.mobileMedia.matches ? this.panelStack[this.panelStack.length - 1] : null;

      this.isActive = Boolean(currentPanel);
      this.backPanel = currentPanel?.backPanel || '';
      this.titleElement.textContent = currentPanel?.title || '';
      this.header.classList.toggle('yg-mobile-panel-active', this.isActive);
    }

    onDrawerClick(event) {
      if (!this.mobileMedia.matches) {
        return;
      }

      const panelButton = event.target.closest('button[data-panel]');

      if (!panelButton || !this.drawer.contains(panelButton)) {
        return;
      }

      const title = panelButton.getAttribute('data-yg-mobile-panel-title');

      if (title) {
        this.panelStack.push({
          title,
          backPanel: panelButton.getAttribute('data-yg-mobile-back-panel') || ''
        });
      } else if (panelButton.getAttribute('data-panel') === '0') {
        this.panelStack = [];
      } else if (panelButton.getAttribute('data-panel') === '1') {
        this.panelStack.pop();
      }

      this.renderState();
    }

    onHeaderPointerDown(event) {
      if (!this.shouldHandleHeaderBack(event)) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      this.ignoreNextHeaderClick = true;
      this.goBack();
    }

    onHeaderToggleClick(event) {
      if (!this.shouldHandleHeaderBack(event)) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (this.ignoreNextHeaderClick) {
        this.ignoreNextHeaderClick = false;
        return;
      }

      this.goBack();
    }

    shouldHandleHeaderBack(event) {
      return this.isActive && this.mobileMedia.matches && this.toggleButton.contains(event.target);
    }

    goBack() {
      const now = Date.now();

      if (now - this.lastHeaderBackAt < 200) {
        return;
      }

      this.lastHeaderBackAt = now;
      this.preventDrawerHideUntil = now + 600;
      this.switchBackPanel();
    }

    switchBackPanel() {
      if (!this.backPanel || typeof this.drawer.switchToPanel !== 'function') {
        return;
      }

      const panelArgs = this.backPanel.split('-');

      if (this.backPanel === '0') {
        this.panelStack = [];
      } else {
        this.panelStack.pop();
      }

      this.renderState();
      this.drawer.switchToPanel(...panelArgs);
    }

    isProtectingBackNavigation() {
      return Date.now() < this.preventDrawerHideUntil;
    }
  }

  class YGHeaderGearLogo extends HTMLElement {
    connectedCallback() {
      this.section = document.getElementById(this.getAttribute('section-id'));
      this.header = this.section?.querySelector('.header');
      this.gearLogo = this.header?.querySelector('.header__gear-logo');

      if (!this.header || !this.gearLogo) {
        return;
      }

      this.lastScrollY = window.scrollY;
      this.rotation = 0;
      this.targetRotation = 0;
      this.rotationVelocity = 0;
      this.ticking = false;
      this.onScroll = this.onScroll.bind(this);
      this.updateRotation = this.updateRotation.bind(this);
      this.updateMenuState = this.updateMenuState.bind(this);
      this.observer = new MutationObserver(this.updateMenuState);

      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.header.addEventListener('toggle', this.updateMenuState, true);
      this.observer.observe(this.header, {
        attributes: true,
        attributeFilter: ['open', 'aria-expanded'],
        subtree: true
      });

      this.updateMenuState();
      this.updateRotation();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      this.header?.removeEventListener('toggle', this.updateMenuState, true);
      this.observer?.disconnect();

      if (this.animationFrame) {
        window.cancelAnimationFrame(this.animationFrame);
      }
    }

    updateMenuState() {
      const isMenuOpen = Boolean(this.header.querySelector('details[open], navigation-drawer[open], [aria-controls="header-sidebar-menu"][aria-expanded="true"]'));

      this.header.classList.toggle('yg-header-menu-open', isMenuOpen);
    }

    updateRotation() {
      const distance = this.targetRotation - this.rotation;

      this.rotationVelocity = (this.rotationVelocity + distance * 0.025) * 0.82;

      if (Math.abs(distance) < 0.01 && Math.abs(this.rotationVelocity) < 0.01) {
        this.rotation = this.targetRotation;
        this.rotationVelocity = 0;
        this.gearLogo.style.setProperty('--yg-gear-logo-rotation', `${this.rotation}deg`);
        this.ticking = false;
        this.animationFrame = null;
        return;
      }

      this.rotation += this.rotationVelocity;
      this.gearLogo.style.setProperty('--yg-gear-logo-rotation', `${this.rotation}deg`);
      this.animationFrame = window.requestAnimationFrame(this.updateRotation);
    }

    onScroll() {
      const currentScrollY = window.scrollY;
      const delta = currentScrollY - this.lastScrollY;

      this.targetRotation += delta * 0.35;
      this.lastScrollY = currentScrollY;

      if (this.ticking) {
        return;
      }

      this.ticking = true;
      this.animationFrame = window.requestAnimationFrame(this.updateRotation);
    }
  }

  if (!customElements.get('yg-header-gear-logo')) {
    customElements.define('yg-header-gear-logo', YGHeaderGearLogo);
  }

  if (!customElements.get('yg-mobile-navigation-header')) {
    customElements.define('yg-mobile-navigation-header', YGMobileNavigationHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hot-spots"] && !Shopify.designMode) return;
  try {
    
  if (!window.customElements.get('hot-spots-scroll-sequence')) {

    class HotSpotsScrollSequence extends HTMLElement {
      constructor() {
        super();
        this.activeIndex = -1;
        this.isReady = false;
        this.mediaQuery = window.matchMedia('screen and (min-width: 1000px)');
        this.abortController = null;
        this.handleScroll = this.handleScroll.bind(this);
        this.handleDotClick = this.handleDotClick.bind(this);
        this.handleMediaChange = this.handleMediaChange.bind(this);
      }

      connectedCallback() {
        this.isReady = false;
        this.dots = Array.from(this.querySelectorAll('.hot-spot__dot'));
        this.popovers = this.dots.map((dot) => document.getElementById(dot.getAttribute('aria-controls')));
        this.mediaQuery.addEventListener('change', this.handleMediaChange);

        window.customElements.whenDefined('x-popover').then(() => {
          if (!this.isConnected) {
            return;
          }

          this.isReady = true;
          window.requestAnimationFrame(() => this.handleMediaChange());
        });
      }

      disconnectedCallback() {
        this.mediaQuery.removeEventListener('change', this.handleMediaChange);

        if (this.isReady) {
          this.disable();
        }

        this.isReady = false;
      }

      get enabled() {
        return this.dataset.desktopSequence === 'true' && this.mediaQuery.matches && this.dots.length > 0;
      }

      handleMediaChange() {
        if (!this.isReady) {
          return;
        }

        if (this.enabled) {
          this.enable();
        } else {
          this.disable();

          if (this.mediaQuery.matches && this.dots.length > 0) {
            this.setActiveIndex(0, false);
          }
        }
      }

      enable() {
        if (this.abortController) {
          return;
        }

        this.abortController = new AbortController();
        this.addEventListener('click', this.handleDotClick, { signal: this.abortController.signal, capture: true });
        window.addEventListener('scroll', this.handleScroll, { signal: this.abortController.signal, passive: true });
        window.addEventListener('resize', this.handleScroll, { signal: this.abortController.signal, passive: true });
        this.setActiveIndex(this.getScrollIndex(), false);
      }

      disable() {
        if (this.abortController) {
          this.abortController.abort();
          this.abortController = null;
        }

        this.activeIndex = -1;
        this.closeAll();
      }

      handleScroll() {
        this.setActiveIndex(this.getScrollIndex(), true);
      }

      handleDotClick(event) {
        const dot = event.target.closest('.hot-spot__dot');

        if (!dot) {
          return;
        }

        const index = this.dots.indexOf(dot);

        if (index === -1) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        this.setActiveIndex(index, true);
      }

      getScrollIndex() {
        if (this.dots.length <= 1) {
          return 0;
        }

        const rect = this.getBoundingClientRect();
        const scrollableDistance = Math.max(this.offsetHeight - window.innerHeight, 1);
        const progress = Math.min(Math.max(-rect.top / scrollableDistance, 0), 1);

        return Math.min(Math.floor(progress * this.dots.length), this.dots.length - 1);
      }

      setActiveIndex(index, animate) {
        if (index === this.activeIndex) {
          return;
        }

        this.activeIndex = index;
        this.popovers.forEach((popover, popoverIndex) => {
          if (!popover) {
            return;
          }

          if (popoverIndex === index) {
            popover.show(animate);
          } else {
            popover.hide();
          }
        });
      }

      closeAll() {
        this.popovers.forEach((popover) => {
          popover?.hide();
        });
      }
    }

    window.customElements.define('hot-spots-scroll-sequence', HotSpotsScrollSequence);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-back-to-top"] && !Shopify.designMode) return;
  try {
    
  class YGBackToTop extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.yg-back-to-top__button');
      this.button?.addEventListener('click', this.scrollToTop);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.scrollToTop);
    }

    scrollToTop = () => {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    };
  }

  if (!window.customElements.get('yg-back-to-top')) {
    window.customElements.define('yg-back-to-top', YGBackToTop);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-before-after-image-tab"] && !Shopify.designMode) return;
  try {
    
  class YGBeforeAfterImageTab extends HTMLElement {
    connectedCallback() {
      this.panels = Array.from(this.querySelectorAll('.yg-before-after-panel'));
      this.tabFrames = Array.from(this.querySelectorAll('.yg-before-after-tab-frame'));
      this.tabs = Array.from(this.querySelectorAll('.yg-before-after-tab'));
      this.captions = Array.from(this.querySelectorAll('.yg-before-after-mobile-caption'));
      this.tabsShell = this.querySelector('.yg-before-after-tabs-shell');
      this.tabsScroller = this.querySelector('.yg-before-after-tabs-scroller');
      this.duration = Number(this.dataset.autoplayDuration) || 6000;
      this.activeIndex = Math.max(this.panels.findIndex((panel) => panel.classList.contains('is-active')), 0);
      this.autoplayDisabled = false;
      this.autoplayStarted = false;
      this.raf = null;
      this.dragging = false;
      this.abortController = new AbortController();
      this.signal = this.abortController.signal;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const nextIndex = Number(tab.dataset.tabIndex);
          this.setActive(nextIndex, true);

          if (this.autoplayStarted && !this.autoplayDisabled) {
            this.startAutoplay(nextIndex);
          }
        }, { signal: this.signal });
      });

      this.panels.forEach((panel) => {
        const handle = panel.querySelector('.yg-before-after-handle');

        if (!handle) {
          return;
        }

        handle.addEventListener('pointerdown', (event) => this.onPointerDown(event, panel), { signal: this.signal });
        handle.addEventListener('keydown', (event) => this.onKeyDown(event, panel), { signal: this.signal });
      });

      if (this.tabsScroller) {
        this.tabsScroller.addEventListener('scroll', () => this.updateTabGradients(), { signal: this.signal });
        window.addEventListener('resize', () => this.updateTabGradients(), { signal: this.signal });
        this.updateTabGradients();
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio >= 0.5 && !this.autoplayStarted && !this.autoplayDisabled) {
            this.autoplayStarted = true;
            this.startAutoplay(this.activeIndex);
          }
        });
      }, { threshold: [0, 0.5, 1] });

      this.observer.observe(this);
      this.setActive(this.activeIndex, false);
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.observer?.disconnect();
      this.stopAnimation();
    }

    setActive(index, resetPosition) {
      if (!this.panels[index]) {
        return;
      }

      this.activeIndex = index;

      this.panels.forEach((panel, panelIndex) => {
        const isActive = panelIndex === index;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;

        if (isActive && resetPosition) {
          this.setPosition(panel, 50);
        }
      });

      this.tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === index;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.tabFrames.forEach((frame, frameIndex) => {
        frame.classList.toggle('is-active', frameIndex === index);
        frame.style.setProperty('--yg-tab-progress', '0%');
      });

      this.captions.forEach((caption) => {
        caption.classList.toggle('is-active', Number(caption.dataset.captionIndex) === index);
      });

      this.scrollActiveTabIntoView();
    }

    startAutoplay(index) {
      const panel = this.panels[index];

      if (!panel || this.autoplayDisabled) {
        return;
      }

      this.stopAnimation();
      this.classList.add('is-autoplaying');
      this.setActive(index, false);
      this.setPosition(panel, 100);

      const startedAt = performance.now();

      const tick = (now) => {
        if (this.autoplayDisabled) {
          return;
        }

        const progress = Math.min((now - startedAt) / this.duration, 1);
        this.setPosition(panel, 100 - progress * 100);
        this.tabFrames[index]?.style.setProperty('--yg-tab-progress', `${(progress * 100).toFixed(2)}%`);

        if (progress < 1) {
          this.raf = requestAnimationFrame(tick);
          return;
        }

        const nextIndex = (index + 1) % this.panels.length;
        this.setActive(nextIndex, false);
        this.startAutoplay(nextIndex);
      };

      this.raf = requestAnimationFrame(tick);
    }

    stopAnimation() {
      if (this.raf) {
        cancelAnimationFrame(this.raf);
        this.raf = null;
      }
    }

    cancelAutoplay() {
      this.autoplayDisabled = true;
      this.stopAnimation();
      this.classList.remove('is-autoplaying');

      this.tabFrames.forEach((frame) => {
        frame.classList.remove('is-active');
        frame.style.setProperty('--yg-tab-progress', '0%');
      });
      this.tabFrames[this.activeIndex]?.classList.add('is-active');
    }

    onPointerDown(event, panel) {
      event.preventDefault();
      this.cancelAutoplay();
      this.dragging = true;
      this.updateFromPointer(event, panel);

      const move = (moveEvent) => {
        if (this.dragging) {
          this.updateFromPointer(moveEvent, panel);
        }
      };

      const end = () => {
        this.dragging = false;
        window.removeEventListener('pointermove', move);
        window.removeEventListener('pointerup', end);
        window.removeEventListener('pointercancel', end);
      };

      window.addEventListener('pointermove', move);
      window.addEventListener('pointerup', end);
      window.addEventListener('pointercancel', end);
    }

    onKeyDown(event, panel) {
      if (event.code !== 'ArrowLeft' && event.code !== 'ArrowRight') {
        return;
      }

      event.preventDefault();
      this.cancelAutoplay();

      const current = Number.parseFloat(panel.style.getPropertyValue('--yg-slider-position')) || 50;
      const next = event.code === 'ArrowLeft' ? current - 2 : current + 2;

      this.setPosition(panel, next);
    }

    updateFromPointer(event, panel) {
      const rect = panel.getBoundingClientRect();
      const next = ((event.clientX - rect.left) / rect.width) * 100;

      this.setPosition(panel, next);
    }

    setPosition(panel, value) {
      const position = Math.min(Math.max(value, 0), 100);
      const handle = panel.querySelector('.yg-before-after-handle');

      panel.style.setProperty('--yg-slider-position', `${position.toFixed(2)}%`);
      handle?.setAttribute('aria-valuenow', Math.round(position).toString());
    }

    scrollActiveTabIntoView() {
      const activeTabFrame = this.tabFrames[this.activeIndex];

      if (!activeTabFrame || !this.tabsScroller) {
        return;
      }

      const maxScroll = this.tabsScroller.scrollWidth - this.tabsScroller.clientWidth;
      const centeredLeft = activeTabFrame.offsetLeft - (this.tabsScroller.clientWidth - activeTabFrame.offsetWidth) / 2;
      const nextLeft = Math.min(Math.max(centeredLeft, 0), maxScroll);

      this.tabsScroller.scrollTo({ left: nextLeft, behavior: 'smooth' });
      requestAnimationFrame(() => this.updateTabGradients());
    }

    updateTabGradients() {
      if (!this.tabsShell || !this.tabsScroller) {
        return;
      }

      const maxScroll = this.tabsScroller.scrollWidth - this.tabsScroller.clientWidth;

      this.tabsShell.classList.toggle('has-left-gradient', this.tabsScroller.scrollLeft > 1);
      this.tabsShell.classList.toggle('has-right-gradient', maxScroll - this.tabsScroller.scrollLeft > 1);
    }
  }

  if (!window.customElements.get('yg-before-after-image-tab')) {
    window.customElements.define('yg-before-after-image-tab', YGBeforeAfterImageTab);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-function-introduction"] && !Shopify.designMode) return;
  try {
    
  class YGFunctionIntroductionTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.selectTab(tab));
      });
    }

    selectTab(selectedTab) {
      const selectedIndex = selectedTab.getAttribute('data-tab-index');

      this.tabs.forEach((tab) => {
        const isActive = tab === selectedTab;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.panels.forEach((panel) => {
        const isActive = panel.getAttribute('data-panel-index') === selectedIndex;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-function-introduction-tabs')) {
      window.customElements.define('yg-function-introduction-tabs', YGFunctionIntroductionTabs);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-image-card-gradual-change"] && !Shopify.designMode) return;
  try {
    
  class YGImageCardGradualChange extends HTMLElement {
    constructor() {
      super();
      this.ticking = false;
      this.handleViewportChange = this.handleViewportChange.bind(this);
    }

    connectedCallback() {
      this.visual = this.querySelector('.yg-image-card-gradual-change__visual-sticky');
      this.images = Array.from(this.querySelectorAll('[data-gradual-image]'));
      this.cards = Array.from(this.querySelectorAll('[data-gradual-card]'));

      if (!this.visual || !this.images.length || !this.cards.length || window.matchMedia('(max-width: 699px)').matches) {
        return;
      }

      this.setActiveByImageCenter();
      window.addEventListener('scroll', this.handleViewportChange, { passive: true });
      window.addEventListener('resize', this.handleViewportChange);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleViewportChange);
      window.removeEventListener('resize', this.handleViewportChange);
    }

    handleViewportChange() {
      if (this.ticking) {
        return;
      }

      this.ticking = true;
      requestAnimationFrame(() => {
        this.setActiveByImageCenter();
        this.ticking = false;
      });
    }

    setActiveByImageCenter() {
      const visualRect = this.visual.getBoundingClientRect();
      const visualCenter = visualRect.top + visualRect.height / 2;
      const intersectedCard = this.cards.find((card) => {
        const rect = card.getBoundingClientRect();
        return visualCenter >= rect.top && visualCenter <= rect.bottom;
      });

      if (intersectedCard) {
        this.setActiveImage(intersectedCard.dataset.gradualCard);
        return;
      }

      const activeCard = this.cards.reduce((current, card) => {
        const rect = card.getBoundingClientRect();
        const cardCenter = rect.top + rect.height / 2;
        const distance = Math.abs(cardCenter - visualCenter);

        if (!current || distance < current.distance) {
          return { card, distance };
        }

        return current;
      }, null);

      if (!activeCard) {
        this.setActiveImage(this.cards[0].dataset.gradualCard);
        return;
      }

      this.setActiveImage(activeCard.card.dataset.gradualCard);
    }

    setActiveImage(index) {
      this.images.forEach((image) => {
        image.classList.toggle('is-active', image.dataset.gradualImage === index);
      });
    }
  }

  if (!customElements.get('yg-image-card-gradual-change')) {
    customElements.define('yg-image-card-gradual-change', YGImageCardGradualChange);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-marquee"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rowStates = new Map();
    const minimumPlaybackRate = 0.02;

    const setAnimationRate = (animations, playbackRate) => {
      animations.forEach((animation) => {
        animation.playbackRate = Math.max(playbackRate, minimumPlaybackRate);
      });
    };

    const changePlaybackRate = (row, targetRate, duration) => {
      const state = rowStates.get(row);

      if (!state) {
        return;
      }

      if (state.animationFrame) {
        window.cancelAnimationFrame(state.animationFrame);
      }

      const animations = Array.from(row.querySelectorAll('.yg-marquee-item-container'))
        .flatMap((container) => container.getAnimations());
      const startRate = state.playbackRate;
      const endRate = targetRate === 0 ? minimumPlaybackRate : targetRate;
      const startTime = performance.now();

      if (targetRate > 0) {
        setAnimationRate(animations, Math.max(startRate, minimumPlaybackRate));
        animations.forEach((animation) => animation.play());
      }

      const updateRate = (currentTime) => {
        const progress = Math.min((currentTime - startTime) / duration, 1);
        const easedProgress = progress * progress * (3 - 2 * progress);
        const playbackRate = Math.max(startRate, minimumPlaybackRate) + (endRate - Math.max(startRate, minimumPlaybackRate)) * easedProgress;

        state.playbackRate = playbackRate;
        setAnimationRate(animations, playbackRate);

        if (progress < 1) {
          state.animationFrame = window.requestAnimationFrame(updateRate);
        } else {
          state.playbackRate = targetRate;
          state.animationFrame = null;

          if (targetRate === 0) {
            animations.forEach((animation) => animation.pause());
          } else {
            setAnimationRate(animations, targetRate);
          }
        }
      };

      state.animationFrame = window.requestAnimationFrame(updateRate);
    };

    const initializeRows = (root) => {
      root.querySelectorAll('.yg-marquee .yg-marquee-row').forEach((row) => {
        if (rowStates.has(row)) {
          return;
        }

        const onMouseEnter = () => changePlaybackRate(row, 0, 900);
        const onMouseLeave = () => changePlaybackRate(row, 1, 600);

        row.addEventListener('mouseenter', onMouseEnter);
        row.addEventListener('mouseleave', onMouseLeave);
        rowStates.set(row, {
          playbackRate: 1,
          animationFrame: null,
          onMouseEnter,
          onMouseLeave
        });
      });
    };

    const cleanupRows = (root) => {
      root.querySelectorAll('.yg-marquee-row').forEach((row) => {
        const state = rowStates.get(row);

        if (!state) {
          return;
        }

        row.removeEventListener('mouseenter', state.onMouseEnter);
        row.removeEventListener('mouseleave', state.onMouseLeave);

        if (state.animationFrame) {
          window.cancelAnimationFrame(state.animationFrame);
        }

        rowStates.delete(row);
      });
    };

    initializeRows(document);
    document.addEventListener('shopify:section:load', (event) => initializeRows(event.target));
    document.addEventListener('shopify:section:unload', (event) => cleanupRows(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-scroll-video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGScrollVideo extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.wrapper = this;
        this.header = this.querySelector('.section-header');
        this.bottom = this.querySelector('.yg-bottom-content');
        this.mediaWrapper = this.querySelector('.yg-media-wrapper');
        this.media = this.querySelector('.yg-media-inner');
        this.stickyEl = this.querySelector('.yg-scroll-video-sticky');
        const style = getComputedStyle(this.querySelector('.yg-scroll-video-inner'));
        this.sectionWidth =
          this.querySelector('.yg-scroll-video-inner').offsetWidth -
          parseFloat(style.paddingLeft) -
          parseFloat(style.paddingRight);
        this.innerWidth = window.innerWidth;
        this.mediaHeight = this.sectionWidth / parseFloat(this.media.dataset.aspectRatio);
        this.mediaHeightMobile = this.sectionWidth / parseFloat(this.media.dataset.aspectRatioMobile);
        this.mediaQuery = window.matchMedia('(max-width: 699px)');
        this.mediaType = this.media.dataset.type;
        this.autoplay = this.media.dataset.autoplay == 'true';

        if (this.mediaQuery.matches) {
          this.initMobile();
          return;
        }

        this.media.style.width = '0px';
        this.media.style.height = '2px';
        this.progress = 0;
        this.progressSecond = 0;
        this.initDesktopSticky();
        this.handleScroll();
      }
      initDesktopSticky() {
        this.updateStickyLayout = () => {
          const stickyHeight = this.stickyEl.offsetHeight;
          this.stickyOffset = Math.max(0, (window.innerHeight - stickyHeight) / 2);
          this.stickyEl.style.setProperty('--sticky-top', `${this.stickyOffset}px`);
          this.wrapper.style.setProperty('--sticky-height', `${stickyHeight}px`);
          if (this.progress === 0 && this.progressSecond === 0) {
            this.animationStartScroll =
              this.wrapper.getBoundingClientRect().top + window.scrollY - this.stickyOffset;
          }
        };

        this.updateStickyLayout();
        this.stickyResizeObserver = new ResizeObserver(this.updateStickyLayout);
        this.stickyResizeObserver.observe(this.stickyEl);
        window.addEventListener('resize', this.updateStickyLayout);
      }
      initMobile() {
        if (this.mediaType != 'video' || !this.autoplay) return;

        this.mobileVideoObserver = new IntersectionObserver(
          entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                this.media.classList.add('playing', 'full-display');
                this.playVideos();
              } else {
                this.media.classList.remove('playing');
                this.pauseVideos();
              }
            });
          },
          { threshold: 0.25 }
        );
        this.mobileVideoObserver.observe(this.media);
      }
      getVisibleVideos(selector) {
        return Array.from(this.media.querySelectorAll(selector)).filter(video => getComputedStyle(video).display != 'none');
      }
      sendYouTubeCommand(iframe, func, args = []) {
        iframe.contentWindow?.postMessage(JSON.stringify({ event: 'command', func, args }), '*');
      }
      playVideos() {
        this.getVisibleVideos('video').forEach(video => video.play().catch(() => {}));
        this.getVisibleVideos('.yg-youtube-video').forEach(iframe => this.sendYouTubeCommand(iframe, 'playVideo'));
      }
      pauseVideos(reset = false) {
        this.media.querySelectorAll('video').forEach(video => {
          video.pause();
          if (reset) video.currentTime = 0;
        });
        this.media.querySelectorAll('.yg-youtube-video').forEach(iframe => {
          this.sendYouTubeCommand(iframe, 'pauseVideo');
          if (reset) this.sendYouTubeCommand(iframe, 'seekTo', [0, true]);
        });
      }
      syncVideoAutoplay() {
        if (this.mediaType != 'video' || !this.autoplay) return;

        if (this.progressSecond == 100) {
          this.media.classList.add('playing');
          this.playVideos();
        } else {
          this.media.classList.remove('playing');
          this.pauseVideos(true);
        }
      }
      handleScroll() {
        const totalScroll = 1000;
        const halfScroll = totalScroll / 2;
        let lastScrollY = window.scrollY;
        window.addEventListener('scroll', () => {
          const currentScrollY = window.scrollY;
          const scrollDistance = currentScrollY - this.animationStartScroll;

          if (scrollDistance < 0 || this.stickyEl.getBoundingClientRect().top < 0) {
            lastScrollY = currentScrollY;
            return;
          }

          if (currentScrollY > lastScrollY) {
            /* 向下滚动 */

            if (this.progress < 100) {
              this.progress = Math.min(100, Math.max(0, scrollDistance / halfScroll * 100));

              this.wrapper.style.setProperty('--progress', this.progress);
              this.wrapper.style.setProperty('--reverse-progress', 100 - this.progress);

              this.media.style.width = `${(this.innerWidth * this.progress) / 100}px`;

              if (this.progress === 100) {
                this.mediaWrapper.classList.add('center');
              }
            } else {
              this.progressSecond = Math.min(
                100,
                Math.max(0, (scrollDistance - halfScroll) / halfScroll * 100)
              );
              if(this.innerWidth < 700) {
                this.media.style.height = `${(this.mediaHeightMobile * this.progressSecond) / 100}px`;
              } else {
                this.media.style.height = `${(this.mediaHeight * this.progressSecond) / 100}px`;
              }
              const mediaWidth = this.innerWidth - ((this.innerWidth - this.sectionWidth) * this.progressSecond) / 100;
              if(this.innerWidth < 700) {
                this.media.style.width = `${mediaWidth}px`;
              } else {
                this.media.style.width = `${mediaWidth}px`;
              }
            }
            if(this.progressSecond == 100) {
              this.media.classList.add('full-display');
            } else {
              this.media.classList.remove('full-display');
            }
            this.syncVideoAutoplay();
          } else if (currentScrollY < lastScrollY) {
            /* 向上滚动 */

            if (this.progressSecond > 0) {
              this.progressSecond = Math.min(
                100,
                Math.max(0, (scrollDistance - halfScroll) / halfScroll * 100)
              );

              let mediaHeight = 0
              if(this.innerWidth < 700) {
                mediaHeight = Math.max(2, (this.mediaHeightMobile * this.progressSecond) / 100);
              } else {
                mediaHeight = Math.max(2, (this.mediaHeight * this.progressSecond) / 100);
              }
              this.media.style.height = `${mediaHeight}px`;

              const mediaWidth = this.innerWidth - ((this.innerWidth - this.sectionWidth) * this.progressSecond) / 100;

              this.media.style.width = `${mediaWidth}px`;

              if (this.progressSecond === 0) {
                this.mediaWrapper.classList.remove('center');
              }
            } else {
              this.progress = Math.min(100, Math.max(0, scrollDistance / halfScroll * 100));

              this.wrapper.style.setProperty('--progress', this.progress);
              this.wrapper.style.setProperty('--reverse-progress', 100 - this.progress);

              this.media.style.width = `${(this.innerWidth * this.progress) / 100}px`;
            }

            this.syncVideoAutoplay();

            if(this.progressSecond == 100) {
              this.media.classList.add('full-display');
            } else {
              this.media.classList.remove('full-display');
            }
          }

          lastScrollY = currentScrollY;
        });
      }
    }

    if (!customElements.get('yg-scroll-video')) {
      customElements.define('yg-scroll-video', YGScrollVideo);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-shooting-modes"] && !Shopify.designMode) return;
  try {
    
  class YGShootingModes extends HTMLElement {
    constructor() {
      super();
      this.ticking = false;
      this.handleViewportChange = this.handleViewportChange.bind(this);
    }

    connectedCallback() {
      this.visual = this.querySelector('.yg-shooting-modes__visual-sticky');
      this.images = Array.from(this.querySelectorAll('[data-shooting-image]'));
      this.cards = Array.from(this.querySelectorAll('[data-shooting-card]'));

      if (!this.visual || !this.images.length || !this.cards.length || window.matchMedia('(max-width: 699px)').matches) {
        return;
      }

      this.setActiveByImageCenter();
      window.addEventListener('scroll', this.handleViewportChange, { passive: true });
      window.addEventListener('resize', this.handleViewportChange);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleViewportChange);
      window.removeEventListener('resize', this.handleViewportChange);
    }

    handleViewportChange() {
      if (this.ticking) {
        return;
      }

      this.ticking = true;
      requestAnimationFrame(() => {
        this.setActiveByImageCenter();
        this.ticking = false;
      });
    }

    setActiveByImageCenter() {
      const visualRect = this.visual.getBoundingClientRect();
      const visualCenter = visualRect.top + visualRect.height / 2;
      const intersectedCard = this.cards.find((card) => {
        const rect = card.getBoundingClientRect();
        return visualCenter >= rect.top && visualCenter <= rect.bottom;
      });

      if (intersectedCard) {
        this.setActiveImage(intersectedCard.dataset.shootingCard);
        return;
      }

      const activeCard = this.cards.reduce((current, card) => {
        const rect = card.getBoundingClientRect();
        const cardCenter = rect.top + rect.height / 2;
        const distance = Math.abs(cardCenter - visualCenter);

        if (!current || distance < current.distance) {
          return { card, distance };
        }

        return current;
      }, null);

      this.setActiveImage(activeCard ? activeCard.card.dataset.shootingCard : this.cards[0].dataset.shootingCard);
    }

    setActiveImage(index) {
      this.images.forEach((image) => {
        image.classList.toggle('is-active', image.dataset.shootingImage === index);
      });
    }
  }

  if (!customElements.get('yg-shooting-modes')) {
    customElements.define('yg-shooting-modes', YGShootingModes);
  }

  } catch(e) { console.error(e); }
})();
})();
